import { useIoContext, useStore } from '~/contexts';
export function downloadReceiptPdf(openNewTab, apiGatewayHost, invoiceId) {
    if (!invoiceId) return;
    openNewTab("".concat(apiGatewayHost, "/receipt/").concat(encodeURIComponent(invoiceId)));
}
export function useDownloadReceiptPdf() {
    const { browser: { openNewTab } } = useIoContext();
    const apiGatewayHost = useStore((state)=>state.session.apiGatewayHost);
    return {
        downloadReceiptPdf: (invoiceId)=>downloadReceiptPdf(openNewTab, apiGatewayHost, invoiceId)
    };
}
